import { createApolloProvider } from '@vue/apollo-option'
import { ApolloClient, InMemoryCache } from '@apollo/client/core'
import { ApolloLink /*split*/ } from "apollo-link";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "apollo-link-context";
import { onError } from "apollo-link-error";
// import { HttpLink } from 'apollo-link-http';
// import { BatchHttpLink } from 'apollo-link-batch-http';
// import { getMainDefinition } from 'apollo-utilities';
import swal from "sweetalert";

// Name of the localStorage item
const AUTH_TOKEN = "apollo-token";

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({ debugMessage, message, extensions: { category } }) => {
            if (category !== "validation") {
                swal({
                    title: "Oops...",
                    text: debugMessage || message,
                    icon: "error",
                });
            }
        });
    }

    if (networkError) {
        if (networkError.statusCode === 419) {
            swal("Session expired. You need to refresh the page.", {
                button: "Refresh",
            }).then(() => {
                window.location.reload();
            });
        }
    }
});

const authLink = setContext((_, { headers }) => {
    const regex = RegExp("XSRF-TOKEN[^;]+").exec(document.cookie);
    const token = decodeURIComponent(regex ? regex.toString().replace(/^[^=]+./, "") : "");

    return {
        headers: {
            ...headers,
            "X-XSRF-TOKEN": token,
        },
    };
});

// const httpLink = new HttpLink({
//   uri: import.meta.env.VITE_APP_GRAPHQL_DEFAULT_HTTP,
//   credentials: 'include',
// });
// const httpLinkAuth = authLink.concat(httpLink);
// const batchLink = new BatchHttpLink({
//   uri: import.meta.env.VITE_APP_GRAPHQL_DEFAULT_HTTP,
//   credentials: 'include',
// });
// const batchLinkAuth = authLink.concat(batchLink);
// const link = split(
//   // split based on operation type
//   ({ query }) => {
//   const { kind, operation } = getMainDefinition(query)
//   return kind === 'OperationDefinition' && operation === 'subscription'
//   },
//   httpLinkAuth,
//   batchLinkAuth,
// )

// Call this in the Vue app file
export function VueApollo(app) {
    const cache = new InMemoryCache();
    const vocusMobileApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_VOCUS_MOBILE_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });
    const vocusNBNApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_VOCUS_NBN_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });
    const pbxwareApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_PBXWARE_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });

    const tppApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_TPP_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
    });

    const radiusApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_RADIUS_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });

    const lmailApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_LMAIL_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });

    const kamailioApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_KAMAILIO_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });

    const cpanelApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_CPANEL_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });

    const cloudflareApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_CLOUDFLARE_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });

    const smsGlobalApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_SMS_GLOBAL_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
    });

    const defaultApolloClient = new ApolloClient({
        link: ApolloLink.from([
            errorLink,
            authLink,
            createUploadLink({
                uri: import.meta.env.VITE_APP_GRAPHQL_DEFAULT_HTTP,
                credentials: "include",
            }),
        ]),
        cache,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "network-only",
            },
            query: {
                fetchPolicy: "network-only",
            },
        },
        shouldBatch: true,
    });

    // Create vue apollo provider
    const apolloProvider = createApolloProvider({
        defaultClient: defaultApolloClient,
        defaultOptions: {
            $watchQuery: {
                fetchPolicy: "network-only",
            },
            $query: {
                fetchPolicy: "network-only",
            },
        },
        clients: {
            vocusMobile: vocusMobileApolloClient,
            vocusNBN: vocusNBNApolloClient,
            pbxware: pbxwareApolloClient,
            tpp: tppApolloClient,
            radius: radiusApolloClient,
            lmail: lmailApolloClient,
            kamailio: kamailioApolloClient,
            cpanel: cpanelApolloClient,
            cloudflare: cloudflareApolloClient,
            smsGlobal: smsGlobalApolloClient,
        },
        errorHandler(error) {
            console.log(error.graphQLErrors);
        },
    });

    app.use(apolloProvider)
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
    if (typeof localStorage !== "undefined" && token) {
        localStorage.setItem(AUTH_TOKEN, token);
    }

    try {
        await apolloClient.resetStore();
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log("%cError on cache reset (login)", "color: orange;", e.message);
    }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
    if (typeof localStorage !== "undefined") {
        localStorage.removeItem(AUTH_TOKEN);
    }

    try {
        await apolloClient.resetStore();
    } catch (e) {
        // eslint-disable-next-line no-console
        console.log("%cError on cache reset (logout)", "color: orange;", e.message);
    }
}
